module.exports = __webpack_public_path__ + "img/callOutCards.a13f5a71.png";